import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "delivery__notice"
};
const _hoisted_2 = {
    key: 0,
    class: "delivery__notice-comment"
};
const _hoisted_3 = { class: "data-item__section-subtitle" };
const _hoisted_4 = { class: "delivery__notice-comment-text" };
const _hoisted_5 = { class: "data-item__section-title" };
const _hoisted_6 = { class: "delivery__items" };
const _hoisted_7 = { class: "table table--condensed" };
const _hoisted_8 = { class: "delivery__comment form form--simple" };
const _hoisted_9 = { class: "form__group" };
const _hoisted_10 = { class: "form__label-wrapper" };
const _hoisted_11 = {
    class: "form__label",
    for: "delivery-comment"
};
const _hoisted_12 = { class: "form__control-wrapper" };
const _hoisted_13 = { class: "delivery__image form form--simple" };
const _hoisted_14 = { class: "form__group" };
const _hoisted_15 = { class: "form__label-wrapper" };
const _hoisted_16 = {
    class: "form__label",
    for: "delivery-image"
};
const _hoisted_17 = { class: "form__control-wrapper" };
import { ref, watch } from "vue";
import alerts, {} from "@astina/paloma-common-ui/src/services/Alerts";
import trans from "@astina/paloma-common-ui/src/services/Translator";
import VensoDeliveryItem from "@/components/VensoDeliveryItem.vue";
import VensoDeliveryImageZone from "@/components/VensoDeliveryImageZone.vue";
import VensoDeliveryImage from "@/components/VensoDeliveryImage.vue";
import vensoRepository from "@/services/VensoRepository";
export default /*@__PURE__*/ _defineComponent({
    __name: 'VensoDelivery',
    props: {
        delivery: {}
    },
    emits: ['updateReceivedQuantity', 'updateComment', 'updateImage'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const comment = ref(props.delivery.comment);
        watch(() => props.delivery, () => comment.value = props.delivery.comment);
        function onUpdateReceivedQuantity(item, qty) {
            emit('updateReceivedQuantity', item, qty);
        }
        function onCommentUpdate() {
            emit('updateComment', comment.value);
        }
        function uploadFile(file) {
            const alert = alerts.info(trans('upload.image_upload_starting', { filename: file.name }), undefined, {
                timeout: 0, // no timeout
            });
            return vensoRepository.uploadDeliveryReceiptImage(props.delivery.id, file)
                .then(response => {
                alerts.success(trans('upload.image_upload_success', { filename: file.name }), undefined, { 'timeout': 5000 });
                emit('updateImage', response.deliveryImageUris);
                return response;
            })
                .catch((e) => {
                alerts.error(trans('upload.image_upload_error', { filename: file.name }));
                return e;
            })
                .finally(alert.dismiss);
        }
        function removeImage(imageUri) {
            return vensoRepository.removeDeliveryReceiptImage(props.delivery.id, imageUri)
                .then(response => {
                alerts.success(trans('upload.image_remove_success'), undefined, { 'timeout': 5000 });
                emit('updateImage', response.deliveryImageUris);
                return;
            })
                .catch((e) => {
                alerts.error(trans('upload.image_remove_error'));
                return e;
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (__props.delivery.deliveryNotice)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (__props.delivery.deliveryNotice?.comment)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('venso_delivery.notice_comment')), 1),
                                _cache[1] || (_cache[1] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_4, _toDisplayString(__props.delivery.deliveryNotice.comment), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _cache[10] || (_cache[10] = _createTextVNode()),
                _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('venso_order.items')), 1),
                _cache[11] || (_cache[11] = _createTextVNode()),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("table", _hoisted_7, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('venso_order_item.position')), 1),
                                _cache[2] || (_cache[2] = _createTextVNode()),
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('venso_article')), 1),
                                _cache[3] || (_cache[3] = _createTextVNode()),
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('venso_article.id')), 1),
                                _cache[4] || (_cache[4] = _createTextVNode()),
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('venso_order_item.quantity_ordered')), 1),
                                _cache[5] || (_cache[5] = _createTextVNode()),
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('venso_order.notified')), 1),
                                _cache[6] || (_cache[6] = _createTextVNode()),
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('venso_delivery_receipt')), 1)
                            ])
                        ]),
                        _cache[7] || (_cache[7] = _createTextVNode()),
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.delivery.items, (item, index) => {
                                return (_openBlock(), _createBlock(VensoDeliveryItem, {
                                    item: item,
                                    key: index,
                                    onUpdateReceivedQuantity: qty => onUpdateReceivedQuantity(item, qty)
                                }, null, 8, ["item", "onUpdateReceivedQuantity"]));
                            }), 128))
                        ])
                    ])
                ]),
                _cache[12] || (_cache[12] = _createTextVNode()),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('venso_delivery_receipt.comment')), 1)
                        ]),
                        _cache[8] || (_cache[8] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_12, [
                            _withDirectives(_createElementVNode("textarea", {
                                class: "form__control",
                                id: "delivery-comment",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((comment).value = $event)),
                                onChange: onCommentUpdate,
                                maxlength: "1000",
                                name: "comment"
                            }, null, 544), [
                                [_vModelText, comment.value]
                            ])
                        ])
                    ])
                ]),
                _cache[13] || (_cache[13] = _createTextVNode()),
                _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('venso_delivery_receipt.image')), 1)
                        ]),
                        _cache[9] || (_cache[9] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_17, [
                            _createVNode(VensoDeliveryImageZone, {
                                upload: uploadFile,
                                "upload-disabled": false,
                                "upload-visible": true
                            }, {
                                images: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.delivery.deliveryImageUris, (imageUri) => {
                                        return (_openBlock(), _createBlock(VensoDeliveryImage, {
                                            key: imageUri,
                                            "image-uri": imageUri,
                                            onRemove: removeImage
                                        }, null, 8, ["image-uri"]));
                                    }), 128))
                                ]),
                                _: 1
                            })
                        ])
                    ])
                ])
            ]));
        };
    }
});
